// export const BASE_URL = "http://localhost:4000"
export const BASE_URL = "https://quicknote-api.onrender.com"